import { render, staticRenderFns } from "./Crud.vue?vue&type=template&id=5bea183a&scoped=true"
import script from "./Crud.vue?vue&type=script&lang=js"
export * from "./Crud.vue?vue&type=script&lang=js"
import style0 from "./Crud.vue?vue&type=style&index=0&id=5bea183a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bea183a",
  null
  
)

export default component.exports